import styled from "@emotion/styled";

export const Root = styled.div`
  display: flex;
  flex: 1;
`;
